import React, { Component } from 'react';
import './ConfirmData.css';
import logoblue from '../../image/logoblue.png'
import { Link } from 'react-router-dom';
import Navbar from '../Components/Navbar/Navbar'
import  smartphone  from '../../image/smartphone.svg'
import { LinkAPI } from '../../API/API'
import HandleRes from '../Components/HandleRes/HandleRes';
import axios from 'axios'
import Footer from '../Components/Footer/Footer'

class ConfirmPhone extends Component {
    constructor(props) {
        super(props);
        this.state = {
            code: "",
            codeError: "",
            Verifycode:false,
            sendcode:false,
            res_sendcodedone:false,
            networkError: false,
            errordataCodemessage: false,
            errordatamessageCodetext: '',
            hasError: false,
        }
    }


    handleChange = event => {
        const isCheckbox = event.target.type === "checkbox";
        this.setState({
            [event.target.name]: isCheckbox
                ? event.target.checked
                : event.target.value
        });
    };

    validatephone = () => {
        let phoneError = "";
      
      
        if ( isNaN(this.state.phone)|| this.state.phone.length < 10 ||this.state.phone.length > 11 ) {
            phoneError = "invalid phone Numper";
        }
        
        if (phoneError) {
            this.setState({ phoneError });
            return false;
        }
        return true;
    };
    validate = () => {
        let codeError = "";

        if (this.state.code.length !== 4 || isNaN(this.state.code)) {
            codeError = "write your code correct";
        }
        
        if (codeError) {
            this.setState({ codeError });
            return false;
        }
        return true;
    };
    resendcode=()=>{
        const Token =localStorage.getItem("userTokentConfirmData")
        axios.put(`${LinkAPI}/api/businessowner/resendcode`,{},{
            headers:{
              Authorization:`${Token}`,
              confirm:true
            }
          }).then(res =>{
            this.setState({
               sendcode:true,
               res_sendcodedone:true,

              })
              setTimeout(() => {
                this.setState({
                    res_sendcodedone:false
                })
        }, 2000);
              }).catch(error=>{
                if (!error.response) {
                    this.setState({
                        networkError: true
                    })
                }  else if (error.response.data.message) {
                    this.setState({
                        errordatamessage: true,
                        errordatamessagetext: error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
              })
    }

    
    sendphone = event => {
        event.preventDefault();
        const { phone} = this.state
        const Token = localStorage.getItem("userTokentConfirmData")
        const isValid = this.validatephone();
        if (isValid) {

            axios.put(`${LinkAPI}/api/businessowner/sendcode`,{ phone:20+phone.replace(/^0+/, '')},{
                headers:{
                  Authorization:`${Token}`
                }
              }
              ).then(res =>{
                this.setState({
                    Verifycode  : true
                })
                }).catch(error=>{
                if (!error.response) {
                    this.setState({
                        networkError: true
                    })
                }  else if (error.response.data.message) {
                    this.setState({
                        codeError: "",
                        errordataCodemessage: true,
                        errordatamessageCodetext: error.response.data.message,
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
                })
                    }
    };
    handleSubmit = event => {
        event.preventDefault();
        const { code ,phone} = this.state
        const Token = localStorage.getItem("userTokentConfirmData")
        const isValid = this.validate();
        if (isValid) {

            axios.post(`${LinkAPI}/api/businessowner/confirmphone`,{ phone:20+phone.replace(/^0+/, ''),code:code},{
                headers:{
                  Authorization:`${Token}`
                }
              }
              ).then(res =>{
                localStorage.setItem("userToken", res.data.token)
// if(res.data.businessOwner.name){
//     localStorage.setItem("KaynuserName", res.data.businessOwner.name)

// }
                window.location.replace("/orders");
                }).catch(error=>{
                if (!error.response) {
                    this.setState({
                        networkError: true
                    })
                }  else if (error.response.data.message) {
                    this.setState({
                        codeError: "",
                        errordataCodemessage: true,
                        errordatamessageCodetext: error.response.data.message,
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
                })
                    }
    };
    render() {
        document.title ="Kayn |  Confirm Phone"; 
        document.getElementsByTagName("META")[1].content="Kayn  Confirm Phone";
        document.documentElement.lang = 'en';
        return (
            <div className="AppEN ConfirmData">
                <Navbar />
                <div className='container '>
                    
                        <div className="Sign  row">
                            <div className="logoform col-6 d-flex align-content-end flex-wrap">
                                <div className="col-12 text-center mt-auto p-2 bd-highlight"><Link to="/"><img className="logo" src={logoblue} alt="Kayn" /></Link>       </div>
                                <p className="fontsize2 text-center mb-5 col-12">Your package...your way</p>
                            </div>
                            <div className="col-md-6 form text-center   ">
                                    {(!this.state.Verifycode?
                                     <div className="px-lg-5 textconfirm">
                                       <div className="form-group my-4 nocounter">
                                       <img className="my-3 warningimg" src={smartphone} alt="smartphone" /><br/> 
                                       <label className="text-muted fontsize9 py-3">Write your phone number</label>
                                            <div className="relative">
                                            <span className="codephone">+20</span>
                                            <input type="number" className={"form-control badge-pill pl-5 p-3 " + (this.state.phoneError ? 'is-invalid' : '')} placeholder="phone" name="phone" value={this.state.phone} onChange={this.handleChange} required/>
                                            </div>
                                            <div style={{ fontSize: 12, color: "red" }}>
                                                {this.state.phoneError}
                                            </div>
                                        </div>
                                        <button  onClick={this.sendphone} className="btn badge-pill p-2 pl-1 px-3 my-4 border shadow btn-primary" >confirm</button>

                                    </div>
                                    :
                                    <div className="px-lg-5">
                                        <div className=" px-lg-5 textconfirm nocounter">
                                        <img className="mt-2 warningimg" src={smartphone} alt="smartphone" /><br/> 
                                            <label className="text-muted fontsize9 py-3">Verify your phone number</label>
                                            <input type="text" className={"form-control badge-pill p-3 " + (this.state.codeError ? 'is-invalid' : '')} placeholder="Enter Code " name="code" onChange={this.handleChange} value={this.state.code} />
                                        </div>
                                        <div style={{ fontSize: 12, color: "red", }}>
                                            {this.state.codeError}
                                        </div>
                                        {(this.state.errordataCodemessage ?
                                            <div className="p-2" style={{ fontSize: 12, color: "red" }}>
                                                {this.state.errordatamessageCodetext}
                                            </div> : '')}
                                            {this.state.sendcode?'':<p className="pointer fontsize11 text-muted py-1 my-1" onClick={this.resendcode}>Resend Code ?</p>}
                                            <button  onClick={this.handleSubmit} className="btn badge-pill p-2 pl-1 px-3 my-4 border shadow btn-primary" >confirm</button>

                                    </div>)}
                            </div>
                        </div> 
                </div>
                {(this.state.res_sendcodedone ? <HandleRes title="Massage has been sent" stylecss="alert-success" /> : '')}
                {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}
                <Footer/>

            </div>
        )
    }
}
export default ConfirmPhone;